<template>
    <nav class="navbar has-background-grey-lighter" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
        <router-link class="navbar-item" :to="{name: 'home'}">
            <img :src="HIcon" alt="HEAT Logo">
        </router-link>
        <div class="navbar-item is-inline">
            <router-link class="navbar-item" :to="{name: 'home'}">
                <div class="title is-6 is-marginless"><div class="heat-logo-blue"> Hager Environmental &</div><div class="heat-logo-green">Atmospheric Technologies</div></div>
            </router-link>
        </div>
        <a role="button" :class="[burgerOpen ? 'is-active': '']" class="navbar-burger burger" aria-label="menu" aria-expanded="false"
           data-target="heatNavbar" @click="burgerOpen = !burgerOpen">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
        </a>
    </div>
    <div id="heatNavbar" class="navbar-menu" :class="[burgerOpen ? 'is-active': '']">
        <div class="navbar-start">
            <router-link class="navbar-item" :to="{name: 'home'}">
                Home
            </router-link>
            <router-link class="navbar-item" :to="{name: 'list-files'}">
                Files
            </router-link>
            <router-link class="navbar-item" :to="{name: 'list-reports'}">
                Data
            </router-link>
        </div>
        <div class="navbar-end">
            <div class="navbar-item has-dropdown is-hoverable">
                <router-link :to="{name: 'user-profile'}" class="navbar-link">
                    {{ username.padStart(17, "&nbsp;") }}
                </router-link>

                <div class="navbar-dropdown dropdown-right">
                    <router-link :to="{name: 'user-profile'}" class="navbar-item">
                        My Account
                    </router-link>
                    <a class="navbar-item" :href="urls.main_site + 'contact'">
                        Contact
                    </a>
                    <div v-if="isStaff">
                        <hr class="navbar-divider">
                        <router-link class="navbar-item"  :to="urls.admin_site">
                            Admin Site
                        </router-link>
                    </div>
                    <hr class="navbar-divider">
                    <a class="navbar-item" @click="logout">
                        Logout
                    </a>
                </div>
            </div>
            <div class="navbar-item"></div>
<!--            <div v-else class="navbar-item">-->
<!--                <div class="buttons">-->
<!--                    <a :href="urls.login" class="button is-primary is-light">-->
<!--                        Log in-->
<!--                    </a>-->
<!--                </div>-->
<!--            </div>-->
        </div>
    </div>
</nav>

</template>

<script>
    import {mapGetters, mapState} from "vuex";
    import axios from "axios";
    import urls from "../urls";
    import HIcon from "heat-shared/static/H.png";

    export default {
        name: "Navbar",
        data: function(){return {
            burgerOpen: false,
        }},
        computed: {
            ...mapState('user', [
                'username',
                'isStaff'
            ]),
            HIcon: () => HIcon,
        },
        methods: {
            async logout() {
                await this.$store.dispatch('user/logout');
                this.$store.commit('files/clearFiles');
                this.$router.push({name: 'home'})
            },
        },
        mixins: [urls],
    }
</script>

<style scoped>

</style>